import axios from "axios";
import { MessageBox } from "element-ui";
import { getErrorMessage, isErrorHandled } from "../utils/errors";

let activeErrorAlert = false;

function resolveBaseURL() {
  if (process.env.VUE_APP_API_BASE_URL) {
    return process.env.VUE_APP_API_BASE_URL;
  }
  return "https://peisong.zy10086.cn/api";
}

const http = axios.create({
  baseURL: resolveBaseURL(),
  timeout: 15000,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("ps_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function shouldShowErrorAlert(error) {
  const method = (error?.config?.method || "").toLowerCase();
  return ["post", "put", "patch", "delete"].includes(method);
}

function showErrorAlert(error) {
  if (!shouldShowErrorAlert(error)) return;

  setTimeout(() => {
    if (isErrorHandled(error) || activeErrorAlert) return;
    activeErrorAlert = true;
    MessageBox.alert(getErrorMessage(error, "操作失败"), "操作失败", {
      type: "error",
      confirmButtonText: "知道了",
      callback: () => {
        activeErrorAlert = false;
      },
    });
  }, 0);
}

http.interceptors.response.use(
  (response) => response,
  (error) => {
    showErrorAlert(error);
    return Promise.reject(error);
  }
);

export default http;
